export const NAV_ITEMS = [
  { id: "ai-lab", label: "今日研判", shortLabel: "研判", description: "今日 AI 研究总览", section: "core", showInSidebar: true },
  { id: "ai-market", label: "市场环境", shortLabel: "市场", description: "外围与 A 股市场状态", section: "core", showInSidebar: false },
  { id: "ai-sectors", label: "板块研究", shortLabel: "板块", description: "热点方向与失效条件", section: "core", showInSidebar: true },
  { id: "ai-stocks", label: "个股研究", shortLabel: "个股", description: "候选逻辑与关键观察位", section: "core", showInSidebar: true },
  { id: "tracking", label: "持续跟踪", shortLabel: "跟踪", description: "研究对象后续表现", section: "core", showInSidebar: true },
  { id: "archive", label: "研究档案", shortLabel: "档案", description: "版本化历史研究记录", section: "core", showInSidebar: true },
  { id: "market", label: "市场概览", shortLabel: "概览", description: "市场宽度与风险状态", section: "tools", showInSidebar: true },
  { id: "scan", label: "规则扫描", shortLabel: "扫描", description: "确定性规则候选漏斗", section: "tools", showInSidebar: true },
  { id: "candidates", label: "证券研究库", shortLabel: "证券", description: "全量证券事实与规则审计", section: "tools", showInSidebar: true },
  { id: "alerts", label: "观察提醒", shortLabel: "提醒", description: "条件变化与人工复核", section: "tools", showInSidebar: true },
  { id: "ai-evidence", label: "证据审计", shortLabel: "证据", description: "来源、缺失与数据冲突", section: "system", showInSidebar: true },
  { id: "methods", label: "研究方法", shortLabel: "方法", description: "规则、视角与验证门禁", section: "system", showInSidebar: true },
  { id: "quality", label: "数据质量", shortLabel: "质量", description: "覆盖、缺失与来源血缘", section: "system", showInSidebar: true }
] as const;

export type RouteId = (typeof NAV_ITEMS)[number]["id"];

export function isRouteId(value: string): value is RouteId {
  return NAV_ITEMS.some((item) => item.id === value);
}
